import { render } from "./SongsView.vue?vue&type=template&id=510be512&scoped=true"
import script from "./SongsView.vue?vue&type=script&lang=js"
export * from "./SongsView.vue?vue&type=script&lang=js"

import "./SongsView.vue?vue&type=style&index=0&id=510be512&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510be512"]])

export default __exports__